{
  "mask": {
    "boundsGroup": {
      "title": "Grenzen"
    },
    "generalGroup": {
      "hidden": "Versteckt",
      "disabled": "Deaktiviert"
    },
    "conditionsGroup": {
      "title": "Bedingungen",
      "requiredExpressions": "Pflichtfeld wenn",
      "disabledExpressions": "Deaktiviert wenn",
      "hiddenExpressions": "Ausblenden wenn"
    },
    "requestPayloadGroup": {
      "title": "Nutzlast anfordern",
      "contentType": "Inhaltstyp",
      "body": "Körper",
      "textPlain": "Einfacher Text",
      "textCsv": "Tabellenkalkulation (CSV)",
      "applicationJson": "Json-Daten",
      "applicationXWwwFormUrlencoded": "Formulardaten"
    },
    "validationGroup": {
      "title": "Validierung",
      "required": "Erforderlich",
      "validationMinLength": "Mindest. Länge",
      "validationMaxLength": "max. Länge"
    },
    "wflBehaviourGroup": {
      "title": "Schicht",
      "description": "Beschreibung",
      "enabled": "Ermöglicht"
    },
    "authProperty": {
      "method": "Auth-Methode",
      "methods": {
        "none": "Keine / Global",
        "basic": "Basic",
        "bearer": "Träger"
      },
      "basicAuthUsername": "Nutzername",
      "basicAuthPassword": "Passwort",
      "authorization": "Inhaber-Token"
    },
    "boundsProperty": {
      "width": "Breite",
      "marginTop": "Rand oben",
      "marginRight": "Rand rechts",
      "marginBottom": "Rand unten",
      "marginLeft": "Rand übrig"
    },
    "datasourceProperty": {
      "title": "Datenquelle",
      "static": "Statisch",
      "source": "Datenquelle",
      "optionValue": "Wert",
      "optionLabel": "Etikett"
    },
    "expressionsProperty": {
      "title": "Ausdrücke",
      "operator": "Operator",
      "leftOperand": "Linker Operand",
      "rightOperand": "Rechter Operand",
      "disjunctor": "Disjunktor"
    },
    "fieldNameProperty": {
      "title": "Feld"
    },
    "floatingLabelProperty": {
      "title": "Schwebendes Etikett"
    },
    "inputTypeProperty": {
      "title": "Art"
    },
    "labelProperty": {
      "title": "Etikett"
    },
    "nameProperty": {
      "title": "Name"
    },
    "objectProperty": {
      "typeOptions": {
        "string": "Schnur",
        "number": "Anzahl",
        "boolean": "Boolesch",
        "json": "Json",
        "raw-string": "Rohe Zeichenfolge"
      },
      "value": "Wert",
      "key": "Taste",
      "type": "Art"
    },
    "pageNameProperty": {
      "title": "Buchseite"
    },
    "placeholderProperty": {
      "title": "Platzhalter"
    },
    "requiredProperty": {
      "title": "Erforderlich"
    },
    "slugProperty": {
      "title": "Schnecke"
    },
    "tagsProperty": {
      "title": "Stichworte",
      "placeholder": "Stichworte"
    },
    "validationContentTypeProperty": {
      "validationContentType": "Inhaltstyp",
      "validateContentTypeRegex": "Regex",
      "validateContentTypeRegexPlaceholder": "z.B. ^[a-z0-9]+$",
      "validateContentTypeDateBefore": "Vor",
      "validateContentTypeDateBeforePlaceholder": "z.B. {{date \"jetzt\"}}",
      "validateContentTypeDateAfter": "Nach",
      "validateContentTypeDateAfterPlaceholder": "z.B. {{date \"jetzt\"}}",
      "validateContentTypeMessage": "Inhaltstyp Nachricht"
    }
  }
}